import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Router } from '@angular/router';

import { TranslateModule } from '@ngx-translate/core';

import { SocialNetworks, StaticContentPage, staticContentPageRouting } from '@shared/models';
import { IconComponent } from '@shared/components';
import { defaultEmail } from '@shared/constants';

@Component({
  selector: 'rp-home-footer',
  standalone: true,
  imports: [IconComponent, TranslateModule],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FooterComponent {
  readonly socialNetworks = SocialNetworks;
  readonly email = defaultEmail;

  readonly linkToPrivacyPolicy = StaticContentPage.privacyPolicy;
  readonly linkToWebmasterTermsAndConditions = StaticContentPage.webmasterTermsAndConditions;
  readonly linkToAdvertiserTermsAndConditions = StaticContentPage.advertiserTermsAndConditions;

  private readonly _router = inject(Router);

  navigateToPage(page: StaticContentPage): void {
    this._router.navigate([staticContentPageRouting[page]]);
  }
}
